// extracted by mini-css-extract-plugin
module.exports = {"container":"Gw7RpG","title":"x9t5oe"};